// extracted by mini-css-extract-plugin
export default {"root":"HamburgerToCross_root__eDSOQ","open":"HamburgerToCross_open__sUnvK"};